import { TranslationKey } from "../../../../shared/i18n/i18n";
import { FieldVisibility } from "../../common/FieldVisibilityIcon";
import { AdminDetailLabel } from "./AdminDetailLabel";

type AdminSelectFieldOption = {
  disabled?: boolean;
  label: string;
  value: string;
};

type AdminSelectFieldProps = {
  isReadOnly: boolean;
  label: string;
  onChange: (value: string) => void;
  options: AdminSelectFieldOption[];
  t: (key: TranslationKey) => string;
  value: string;
  visibility: FieldVisibility;
};

export const AdminSelectField = ({
  isReadOnly,
  label,
  onChange,
  options,
  t,
  value,
  visibility,
}: AdminSelectFieldProps) => {
  const selectedLabel = options.find((option) => option.value === value)?.label ?? value;

  return (
    <label className="admin-detail-field">
      <AdminDetailLabel
        label={label}
        t={t}
        visibility={visibility}
      />
      {isReadOnly ? (
        <input
          className="admin-detail-input"
          readOnly
          type="text"
          value={selectedLabel}
        />
      ) : (
        <select
          className="admin-detail-input admin-detail-select"
          onChange={(event) => onChange(event.target.value)}
          value={value}
        >
          {options.map((option) => (
            <option
              disabled={option.disabled}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      )}
    </label>
  );
};
